var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotes = function SvgNotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#212fcc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1038.507 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1038.507 16)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1042.334 6.975)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.54 18.512)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.073,15.988H1.56A1.562,1.562,0,0,0,0,17.548v8.322a1.562,1.562,0,0,0,1.56,1.56h1.56v2.6a.521.521,0,0,0,.888.368l2.816-2.816a.519.519,0,0,1,.368-.153h5.88a1.562,1.562,0,0,0,1.56-1.56V17.548A1.562,1.562,0,0,0,13.073,15.988ZM2.6,19.109H9.952a.52.52,0,1,1,0,1.04H2.6a.52.52,0,1,1,0-1.04Zm5.271,5.2H2.6a.52.52,0,0,1,0-1.04H7.872a.52.52,0,0,1,0,1.04Zm4.161-2.081H2.6a.52.52,0,0,1,0-1.04h9.432a.52.52,0,1,1,0,1.04Z",
    transform: "translate(0 -15.988)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Notes.ed6d1c58.svg";
export { ForwardRef as ReactComponent };